// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"629":"da1af30a","672":"4e04c9b1","842":"a75ca7a7"}[chunkId] + ".chunk.js";
};